import { SamplesLanguages } from 'types/enums';

export const defaultLocale = SamplesLanguages.EN;
